export enum RemainDemandOption {
  First,
  Second
}

export interface IBaseFertStatistic {
  Min: number;
  Max: number;
  Average: number;
}

export type RemainingDemand = {
  P: number | undefined,
  K: number | undefined,
  Mg: number | undefined,
  CaO: number | undefined,
  N: number | undefined
};
